import { db } from '@/data/firebase/config';
import { Timestamp, collection, getDocs, orderBy, query, where } from 'firebase/firestore';
import { useCallback, useState } from 'react';

export type CampaignMention = {
  id: string;
  userId: string;
  userName: string;
  userDocument: string;
  hashtag: string;
  comment: string;
  commentId: string;
  publicationId: string;
  publicationTitle: string;
  collectionName: string;
  createdAt: Timestamp;
};

const useCampaignMentions = (campaignId: string) => {
  const [mentions, setMentions] = useState<CampaignMention[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchByUser = useCallback(
    async (userId: string) => {
      setIsLoading(true);
      try {
        const q = query(
          collection(db, 'campaigns', campaignId, 'mentions'),
          where('userId', '==', userId),
          orderBy('createdAt', 'desc'),
        );
        const snap = await getDocs(q);
        setMentions(
          snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<CampaignMention, 'id'>) })),
        );
      } finally {
        setIsLoading(false);
      }
    },
    [campaignId],
  );

  const clear = useCallback(() => setMentions([]), []);

  return { mentions, isLoading, fetchByUser, clear };
};

export default useCampaignMentions;
